import {mapState} from "vuex";
export default {
    name: "poll-review",
    data() {
        return {
            select_meeting: null,
            assign_mode: 0,
            dialogFormVisible: false,
            approve_form: {approve_result: '2'},
            qrcode: null,
            meetings: [],
        }
    },
    components: {},
    props: {
        view_mode: {
            type: Boolean,
            default() {
                return false;
            }
        },
        single: {
            type: Object,
            default() {
                return {};
            }
        },
        show_meeting:{
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    computed:{
        ...mapState(['process'])
    },
    watch: {
        view_mode: {
            handler(newVal) {
                this.dialogFormVisible = newVal;
            }
        },
    },
    methods: {
        handleClose() {
            this.$emit('update:view_mode', false);
        },
        toArray(str) {
            const s = str.replaceAll('，', ',');
            return s.split(',');
        },
        handleAssign() {
            this.$emit('assign', {meeting_id:this.select_meeting,poll_id:this.single.id,mode:this.assign_mode});
        },
        remoteMethod(query) {
            if (this.show_meeting) {
                this.$api('Query.Meeting.Search', {search: query}, 1).then(res => {
                    this.meetings = [];
                    res.data.data.forEach(item => {
                        this.meetings.push(item);
                    });
                });
            }
        }
    },
    mounted() {
        if (!this.meetings.length) {
            this.remoteMethod();
        }
    }
}
